<script>
  export let img = {
    src: '',
    alt: 'Unlabled',
  };

  export let label;
  export let clickFn;
  export let backgroundColour;
  export let selected;
</script>

<div class="card-container">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="card" on:click={clickFn} class:border={selected} style="background-color: rgb{backgroundColour};">
    {#if img.src}
      <img src={img.src} alt={img.alt} />
    {/if}

    <slot />
  </div>
  {#if label}
    <div class="label">
      {label}
    </div>
  {/if}
</div>

<style>
  .card-container {
    display: flex;
    flex-direction: column;
  }

  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 1rem;
    border-radius: 1rem;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    flex: 1;
  }

  img {
    max-height: 120px;
    max-width: 100%;
  }

  .border {
    border: 2px solid #fe5900;
  }

  .label {
    display: block;
    text-align: center;
    margin-top: 0.5rem;
    font-weight: 500;
    color: #333;
    text-transform: capitalize;
  }
</style>
